module.exports = __webpack_public_path__ + "static/media/bigDataApplication2.fdac2785.png";